export enum DesignFeatureFlag {
  /** Enable @see InputObjectConfig to use @see ValueOrVariable for several of its properties. */
  inputNumberVariables = 'inputNumberVariables',
  /** Enable the new way of handling intents for the intent management service APIs. */
  intentManagement = 'intentManagement',
  /** Enable multiple TTS voices per language, which can have different texts on each prompt. */
  ttsOverrides = 'ttsOverrides'
}
